import React, { useState } from 'react'
import { WidgetContent, TextField, Select } from '@duik/it'
import CreateNewModal from '../../UI/CreateNewModal'
import { ModalButton } from '../../UI/ModalButton'
import FormInputGroup from '../../UI/FormInputGroup'
import moment from 'moment'
import 'react-datepicker/dist/react-datepicker.css'
import { Tabs, TabItem } from '@duik/it'
import { HaulIdContainer } from '../styles'

const ViewDispatch = ({
  dispatchDetail,
  viewDispatchModalToggle,
  drivers,
  handleEditModalToggle
}) => {
  const [step, setStep] = useState(0) //0, 1, 2

  const startTimes = drivers.map(item => item.startDateTime)
  const startTimeNums = [...new Set(startTimes)]

  const getAssignedDrivers = i => {
    const assignedDrivers = drivers.filter(item => item.startDateTime === startTimeNums[i])
    return assignedDrivers
  }

  return (
    <CreateNewModal title={'Dispatch'} handleCloseModal={viewDispatchModalToggle}>
      <WidgetContent
        style={{
          height: '415px',
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          padding: 0,
          overflowY: 'scroll',
          overflowX: 'hidden'
        }}
        id="dispatch-form"
      >
        <div
          style={{
            width: '100%'
          }}
        >
          <Tabs sm>
            <TabItem className={step === 0 && 'active'} onClick={() => setStep(0)}>
              Details
            </TabItem>
            <TabItem className={step === 1 && 'active'} onClick={() => setStep(1)}>
              Schedule
            </TabItem>
            <TabItem className={step === 2 && 'active'} onClick={() => setStep(2)}>
              Truck Assignments
            </TabItem>
          </Tabs>
        </div>
        {step === 0 && (
          <div style={{ padding: '0 30px' }}>
            <div style={{ paddingTop: '20px' }}>
              <FormInputGroup
                direction={dispatchDetail && dispatchDetail.backHaulId !== '' && 'horizontal'}
              >
                <HaulIdContainer fullWidth={!dispatchDetail.backHaulId}>
                  <TextField
                    className="fullWidthInputBox"
                    label="Haul ID"
                    name="haulId"
                    value={dispatchDetail.haul.haulId}
                    disabled
                  />
                </HaulIdContainer>
                {dispatchDetail.backHaulId && (
                  <HaulIdContainer fullWidth={false}>
                    <TextField
                      className="fullWidthInputBox"
                      label="Back Haul ID"
                      name="backHaulId"
                      value={dispatchDetail.backHaulId}
                      disabled
                    />
                  </HaulIdContainer>
                )}
              </FormInputGroup>

              <div style={{ marginTop: '10px' }}>
                <FormInputGroup>
                  <TextField
                    className="fullWidthInputBox"
                    label="Project"
                    name="project"
                    value={dispatchDetail.project.projectName}
                    disabled
                  />
                </FormInputGroup>
              </div>

              <div style={{ display: 'none' }}>
                <FormInputGroup>
                  <div style={{ paddingTop: '30px' }}>
                    <FormInputGroup>
                      <TextField
                        className="fullWidthInputBox"
                        label="Material"
                        name="material"
                        value={dispatchDetail.material}
                        disabled
                      />
                    </FormInputGroup>
                  </div>
                </FormInputGroup>
              </div>

              <div style={{ paddingTop: '30px' }}>
                <FormInputGroup direction="horizontal">
                  <div style={{ width: '150px' }}>
                    <TextField
                      className="fullWidthInputBox"
                      label="Trucks required"
                      name="trucksRequired"
                      value={dispatchDetail.trucksRequired || ''}
                      disabled
                    />
                  </div>
                  <div style={{ width: '314px' }}>
                    <Select
                      className="optionsFullWidth"
                      activeOption={{ label: dispatchDetail.truckType[0] }}
                      options={dispatchDetail.truckType.map(item => {
                        return { value: item, label: item }
                      })}
                      name="truckType"
                      label="Truck Type"
                      menuPosition="bottom-left"
                    />
                  </div>
                </FormInputGroup>
              </div>

              <FormInputGroup>
                <div style={{ paddingTop: '10px' }}>
                  <Select
                    className="fullWidthSelectBox optionsFullWidth"
                    activeOption={{ label: dispatchDetail.trailerType[0] }}
                    options={dispatchDetail.trailerType.map(item => {
                      return { value: item, label: item }
                    })}
                    name="trailerType"
                    label="Trailer Type"
                    menuPosition="bottom-left"
                  />
                </div>
              </FormInputGroup>
            </div>
          </div>
        )}

        {step === 1 && (
          <div>
            {startTimeNums.map((item, i) => {
              return (
                <div style={{ paddingTop: '20px' }}>
                  <div style={{ padding: '0 30px' }}>
                    <p style={{ color: '#3E3F42', fontSize: '16px' }}>Start {i + 1}</p>
                    <FormInputGroup>
                      <TextField
                        className="fullWidthInputBox"
                        label="Date & Time"
                        name="material"
                        value={moment(startTimeNums[i]).format('MMMM D, YYYY - HH:mm')}
                        disabled
                      />
                    </FormInputGroup>

                    <div style={{ paddingTop: '30px' }}>
                      <FormInputGroup>
                        <TextField
                          className="fullWidthInputBox"
                          label="Start Location"
                          name="startLocation"
                          value={dispatchDetail.startSite[i].siteName}
                          disabled
                        />
                      </FormInputGroup>
                    </div>

                    <div style={{ paddingTop: '30px' }}>
                      <div style={{ marginBottom: '0.5rem' }}>
                        <span className="content-title">DRIVER INSTRUCTIONS</span>
                      </div>
                      <textarea
                        className="fullWidthInputBox uik-input__input"
                        label="Notes"
                        name="notes"
                        style={{ height: '118px', resize: 'none', padding: '16px' }}
                        value={dispatchDetail.notes[i] || ''}
                        disabled
                      />
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        )}

        {step === 2 && (
          <div style={{ width: '100%' }}>
            {startTimeNums.map((item, i) => {
              return (
                <div style={{ padding: '0 30px' }}>
                  <p style={{ color: '#3E3F42', fontSize: '16px', paddingTop: '20px' }}>
                    {moment(item).format('HH:mm')}
                  </p>
                  <div
                    style={{
                      marginTop: '16px',
                      display: 'flex',
                      justifyContent: 'space-between'
                    }}
                  >
                    <span style={{ fontSize: '12px', color: '#9EA0A5' }}>
                      ASSIGNED ({getAssignedDrivers(i).length})
                    </span>
                    <span style={{ fontSize: '14px', color: '#3E3F42' }}>
                      {dispatchDetail.pickUpSite.siteName
                        ? `${dispatchDetail.pickUpSite.siteName} to ${dispatchDetail.dropOffSite.siteName}`
                        : ''}
                    </span>
                  </div>
                  <div
                    style={{
                      marginTop: '8px',
                      height: '150px',
                      overflowY: 'scroll',
                      border: '1px solid #D8DCE6',
                      borderRadius: '4px'
                    }}
                  >
                    <table style={{ width: '100%', padding: '10px 16px' }}>
                      <tbody>
                        {getAssignedDrivers(i).map((item, i) => (
                          <tr style={{ height: '40px' }} key={i}>
                            <td>
                              <span>
                                {item.driverName ? item.driverName : item.driverPhoneNumber}
                              </span>
                            </td>
                            <td>
                              <span>{item.truckType}</span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )
            })}
          </div>
        )}
      </WidgetContent>
      <div style={{ display: 'flex' }}>
        <WidgetContent
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            border: 'none',
            width: '482px'
          }}
        >
          <div style={{ width: '83px' }}>
            <ModalButton
              name={'Close'}
              buttonStyle="tertiary"
              // onClick={handleEditModalToggle}
              onClick={viewDispatchModalToggle}
            />
          </div>
          <div style={{ width: '83px' }}>
            <ModalButton success name={'Ok'} onClick={viewDispatchModalToggle} />
          </div>
        </WidgetContent>
      </div>
    </CreateNewModal>
  )
}

export default ViewDispatch
